import { observer } from 'mobx-react-lite';
import { AppState, Subview } from '../stores/appStateStore';
import { action } from 'mobx';

export interface SubviewButtonProps {
    state: AppState;
    subview: Subview;
}

const SubviewNameMap: Record<Subview, string> = {
    plaintext: 'Plaintext Body',
    html: 'HTML Body',
    headers: 'Headers',
    mime: 'MIME',
    rawHtml: 'Raw HTML',
    attach: 'Attachments'
};

const SubviewButton = observer((props: SubviewButtonProps) => {
	const { state, subview } = props;
    const currentView = state.currentMessage.subview;
    if(subview !== currentView) {
        return (
            <button className="rectangular-btn-gray" onClick={action(() => {
                state.currentMessage.subview = subview;
                state.loadedMore = false;
            })}>{SubviewNameMap[subview]}</button>
        );
    }
    return (
        <button className="rectangular-btn no-hover">{SubviewNameMap[subview]}</button>
    );
});

export default SubviewButton;